import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {Object}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a address groups icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <AddressGroupsIcon width={12} />
 */
const AddressGroupsIcon = props => (
    <SvgIcon viewBox="0 0 48 48" {...props}>
        <path
            d={`M26.677,2.193,16.423,7.2A.872.872,0,0,1,15.05,6.37V3.02a.871.871,
             0,0,0-1.373-.828L3.423,7.2A2.656,2.656,0,0,0,2.05,9.366V34.55H16.7V20.34a5.6,
             5.6,0,0,1,3.057-4.863l8.3-4.05V3.02A.872.872,0,0,0,26.677,2.193ZM13.425,
             29.675h-6.5v-6.5h6.5Zm0-9.75h-6.5v-6.5h6.5Z`}
        />
        <path
            d={`M44.676,13.693a.872.872,0,0,1,1.374.827l0,31.53h-26V20.866A2.656,
             2.656,0,0,1,21.423,18.7l10.255-5.005a.871.871,0,0,1,1.373.828v3.35a.872.872,
             0,0,0,1.373.828ZM31.425,41.175v-6.5h-6.5v6.5Zm0-9.75v-6.5h-6.5v6.5Zm9.75,
             9.75v-6.5h-6.5v6.5Zm0-9.75v-6.5h-6.5v6.5Z`}
        />
    </SvgIcon>
)

AddressGroupsIcon.defaultProps = defaultProps

export { AddressGroupsIcon }
